import axios from "axios";
import { ERRORE_SESSION_EXPIRED } from "../global/messaggioLabels";
import { ROOT } from "../global/urlMapping";
import { generaLog } from "../functions/utils";
import { decrypt } from "../auth/authFunctions";

export const TIMEOUT = 20000;

export const apiAuthGW = axios.create({
    baseURL: process.env.REACT_APP_BASEURL_GW,
    withCredentials: true
});

export const apiProfilazioneGW = axios.create({
    withCredentials: true,
    baseURL: process.env.REACT_APP_BASEURL_GW + process.env.REACT_APP_PROFILAZIONE_GW
});

export const apiProfilazioneTS = axios.create({
    baseURL: process.env.REACT_APP_PROFILAZIONE_TS
})

export const apiAriannaGW = axios.create({
    baseURL: process.env.REACT_APP_BASEURL_GW + process.env.REACT_APP_ARIANNA_GW,
    withCredentials: true,

})

export const apiAriannaTS = axios.create({
    baseURL: process.env.REACT_APP_ARIANNA_TS,

})

export const apiAnagrafeGW = axios.create({
    withCredentials: true,
    baseURL: process.env.REACT_APP_BASEURL_GW + process.env.REACT_APP_ASR_GW,
    headers: { Accept: "*" }
});

export const apiAnagrafeTS = axios.create({
    baseURL: process.env.REACT_APP_ASR_TS
})

export const apiAnagrafePub = axios.create({
    baseURL: process.env.REACT_APP_ASR_PUB
});

export const apiBeSession = axios.create({
    baseURL: process.env.REACT_APP_BE_SESSION,
    withCredentials: true
});

// REQUEST GLOBAL INTERCEPTOR - GW
const apiInstancesRequest = [apiAuthGW, apiProfilazioneGW, apiAriannaGW, apiAnagrafeGW, apiAnagrafePub]

apiInstancesRequest.forEach(instance => {
    instance.interceptors.request.use(function (config) {
        config.timeout = TIMEOUT;
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
})
// END INTERCEPTOR

// REQUEST GLOBAL INTERCEPTOR - TS
const apiInstancesRequestTS = [apiProfilazioneTS, apiAriannaTS, apiAnagrafeTS]

apiInstancesRequestTS.forEach(instance => {
    instance.interceptors.request.use(function (config) {
        if (sessionStorage.expirationDate < new Date().getTime())
            return Promise.reject(ERRORE_SESSION_EXPIRED)
        config.timeout = TIMEOUT;
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
})
// END INTERCEPTOR

// RESPONSE GLOBAL INTERCEPTOR
const apiInstancesResponse = [apiAuthGW, apiProfilazioneGW, apiAriannaGW, apiAnagrafeGW, apiProfilazioneTS, apiAriannaTS, apiAnagrafeTS, apiAnagrafePub]

apiInstancesResponse.forEach(instance => {
    instance.interceptors.response.use(function (response) {
        console.log(response.headers['asl-appartenenza'])
        return response;
    }, function (error) {
        if (error?.response?.status === 409) {
            generaLog("-- Session Expired --", "log")
            window.location.href = ROOT
        }
        return Promise.reject(error);
    });
})
// END INTERCEPTOR

//INTERCEPTORS FOR HEADER ASL WSO2
const apiInstancesRequestHeaderAsl = [apiAriannaGW, apiAriannaTS, apiProfilazioneGW, apiProfilazioneTS]

apiInstancesRequestHeaderAsl.forEach(instance => {
    instance.interceptors.request.use(function (config) {
        let asl;
        if (sessionStorage.ASL?.length > 0)
            asl = decrypt(sessionStorage.ASL)
        config.headers['x-codente'] = asl;
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
})


//END INTERCEPTORS


